// extracted by mini-css-extract-plugin
export default {"statusLabel":"statusLabel_statusLabel__ZzWbn","statusLabel__active":"statusLabel_statusLabel__active__SSCPF","statusLabel__paused":"statusLabel_statusLabel__paused__4BF1O"};